import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import {Router} from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { GameComponentService } from '../game/gameComponent.service';
import { BondMathComponentService } from '../bondmath/bondmathComponent.service';
import { HorizonCalcComponentService } from '../horizoncalc/horizoncalcComponent.service';
import { Subscription }   from 'rxjs/Subscription';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  providers: [GameComponentService, BondMathComponentService, HorizonCalcComponentService],
  encapsulation: ViewEncapsulation.None
})

export class FullLayoutComponent implements OnInit, OnDestroy {

  public location = '';
  public headerType:number = 0;
  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};
  public footerOpen:number = 0;
  public footerVisible:number = 0;
  GCSfooter: Subscription;
  GCSfooterOpen: Subscription;

  @ViewChild('childModal') public childModal:ModalDirective;


  constructor(private  _router : Router, public _srvc: GameComponentService) 
  {      
    this.location = _router.url;

    this._router.events.subscribe(path => {
      //;if(location.hash.startsWith("#/game")){
      if(location.pathname.toLowerCase().startsWith("/game") && 
        !location.pathname.toLowerCase().startsWith("/game/login")){   //trying to get routing w/o #
        this.headerType = 1;
      }

      else if(location.pathname.toLowerCase().startsWith("/bondmath")){
        this.headerType = 2;
      }

      else if(location.pathname.toLowerCase().startsWith("/horizoncalc")){
        this.headerType = 3;
      }

      //add other headers for other apps
      else if (location.pathname.toLowerCase().startsWith("/dashboard")){
        this.headerType = 0; 
      }
       else {
         this.headerType = 0; 
      }
    });
  }

  public toggled(open:boolean):void {
    console.log('Dropdown is now: ', open);
    console.log('Status: ' + status);
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
    console.log('status: ' + this.status.isopen);
  }

  public menuClicked(event){
    this.status.isopen = false;
    console.log(this.status.isopen);
  }

  public showChildModal():void {
    this.childModal.show();
  }

  public hideChildModal():void {
    this.childModal.hide();
  }

  ngOnInit(): void {
    console.log("full-layout.component : ngOnInit");
  }

  ngAfterViewInit() {
    console.log("full-layout.component : ngAfterViewInit");
    this.GCSfooterOpen = this._srvc.FooterOpen$.subscribe(
      res => {
        console.log("FullLayout FooterOpen Update: " + res);
        this.footerOpen = (res ? 1 : 0);
      },
      err => console.log("sub error: " + err),
    );   
    this.GCSfooter = this._srvc.ShowFooter$.subscribe(
      res => {
        //console.log("LY ShowFooter Update: " + res);
        this.footerVisible = (res ? 1 : 0);
      },
      err => console.log("sub error: " + err),
    ); 
  }

  ngOnDestroy() {
    try {
      this.GCSfooter.unsubscribe();
      this.GCSfooterOpen.unsubscribe();      
    }
    catch (ex) {
      
    }    
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts